export default __webpack_public_path__ + "static/media/headerMobileBackground.377f861d.svg";